const About = () => {
    return (
        <div id='about'>
            <h1>Aidan Lynch</h1>
            <h3>Software Engineer from Syracuse, NY</h3>
        </div>
    );
}

export default About;